import { lucidColors } from '@lucid/gatsby-theme-lucid';

export const colors = {
  // Base
  coolGrey: { ...lucidColors.coolGrey },
  fuchsia: { ...lucidColors.fuchsia },
  red: { ...lucidColors.red },
  orange: { ...lucidColors.orange },
  yellow: { ...lucidColors.yellow },
  earth: { ...lucidColors.earth },
  lime: { ...lucidColors.lime },
  green: { ...lucidColors.green },
  teal: { ...lucidColors.teal },
  blue: { ...lucidColors.blue },
  indigo: { ...lucidColors.indigo },
  purple: { ...lucidColors.purple },
  pink: { ...lucidColors.pink },
  // Aliases
  blueSteel: lucidColors.coolGrey[100],
  subheading: lucidColors.coolGrey[100],
  heading: lucidColors.coolGrey[100],
  text: lucidColors.coolGrey[100],
  background: lucidColors.white,
  primary: lucidColors.blue[60],
  primaryText: lucidColors.blue[60],
  secondary: lucidColors.coolGrey[100],
  secondaryText: lucidColors.coolGrey[100],
  grey: lucidColors.coolGrey[10],
  white: lucidColors.white,
  black: lucidColors.black,
  disabled: lucidColors.coolGrey[10],
  disabledBorder: lucidColors.coolGrey[30],
  lucidCoBlue: lucidColors.blue[60]
};

export const colorStyles = {
  primary: lucidColors.indigo[60],
  secondary: lucidColors.coolGrey[90],
  disabled: lucidColors.coolGrey[10]
};
